import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "noDatasetsFound" }
const _hoisted_2 = { class: "table-header p-d-flex" }
const _hoisted_3 = { class: "p-input-icon-left p-mr-3 p-col-12" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { style: {"height":"1.57rem"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")
  const _directive_t = _resolveDirective("t")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary datasetListDialogClass",
    visible: _ctx.visibility,
    header: _ctx.$t('workspace.advancedData.chooseDataset'),
    closable: false,
    modal: "",
    breakpoints: { '960px': '75vw', '640px': '100vw' }
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.cancel
      }, null, 8, ["label", "onClick"]),
      _withDirectives(_createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.apply,
        disabled: !_ctx.isDatasetSelected
      }, null, 8, ["onClick", "disabled"]), [
        [_directive_t, 'common.open']
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        id: "datasets-datatable",
        value: _ctx.filteredDatasets,
        selection: _ctx.selectedDataset,
        selectionMode: "single",
        paginator: true,
        rows: _ctx.KnDatasetListDescriptor.rows,
        loading: _ctx.loading,
        class: "p-datatable-sm kn-table kn-page-content",
        dataKey: "id",
        responsiveLayout: _ctx.KnDatasetListDescriptor.responsiveLayout,
        breakpoint: _ctx.KnDatasetListDescriptor.breakpoint,
        onRowClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClick($event.data)))
      }, {
        loading: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
        ]),
        empty: _withCtx(() => [
          _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        header: _withCtx(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: _ctx.searchWord,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchWord = $event)),
                type: "text",
                placeholder: _ctx.$t('common.search'),
                onInput: _ctx.searchDatasets
              }, null, 8, ["modelValue", "placeholder", "onInput"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.KnDatasetListDescriptor.columns, (col) => {
            return (_openBlock(), _createBlock(_component_Column, {
              class: "kn-truncated",
              style: col.style,
              header: _ctx.$t(col.header),
              key: col.field,
              sortField: col.field,
              sortable: col.field !== 'icon'
            }, {
              body: _withCtx((slotProps) => [
                (col.field !== 'icon')
                  ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_5, [
                      _createTextVNode(_toDisplayString(slotProps.data[col.field]), 1)
                    ], 512)), [
                      [
                        _directive_tooltip,
                        slotProps.data[col.field],
                        void 0,
                        { top: true }
                      ]
                    ])
                  : (_openBlock(), _createBlock("span", _hoisted_6, [
                      _hoisted_7
                    ]))
              ]),
              _: 2
            }, 1032, ["style", "header", "sortField", "sortable"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value", "selection", "rows", "loading", "responsiveLayout", "breakpoint"])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}